import { EditPage, ListPage } from 'adminConsole/page'
import { Route } from 'react-router'

export const CodeMapRoutes = () => {
  return (
    <>
      <Route path="/codeMap" exact component={ListPage} />
      <Route path="/codeMap/:id" component={EditPage} />
    </>
  )
}
